import { createStyles, makeStyles, Theme } from '../../../../UI'

export default makeStyles((theme: Theme) =>
    createStyles({

        titlePayments: {
            fontFamily: 'OutfitHeavy',
            textTransform: 'uppercase',
            fontSize: '16px',
            [theme.breakpoints.down('sm')]: {
                textAlign: 'center',
            },
        },
        subtitle: {
            fontFamily: 'Lato',
            fontSize: '18px',
            color: "#6D6A6F",
            [theme.breakpoints.down('sm')]: {
                textAlign: 'center',
            },
        },

        newPasswordContainer: {
            padding: "16px",
            borderRadius: "8px",
            width: "100%",
            backgroundColor: "#F6F5EF",
            height: "fit-content",
            [theme.breakpoints.down('sm')]: {
                width: "calc(100% - 32px)",
                marginLeft: "16px",
            }
        },
        inputLabel: {
            fontFamily: "LatoBlack",
            fontSize: "18px",
            marginBottom: "4px",
        },
        input: {
            width: "100%",
            height: "60px",
            borderRadius: "8px",
            border: "2px solid #F5F6F7",
            backgroundColor: "#FFFFFF",
            padding: "0 16px",
            fontFamily: "Lato",
            fontSize: "16px",
            "&:focus": {
                outline: "none",
            }
        },
        inputContainer: {
            marginTop: "16px"
        },
        button: {
            color: "white",
            padding: "18px 0",
            width: "100%",
            backgroundColor: "#2F7BF7",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "8px",
            marginTop: "16px",
            cursor: "pointer",
        },
        buttonText: {
            fontFamily: "LatoBold",
            fontSize: "18px",
            margin: 0
        },
        buttonDisabled: {
            color: "#8F9091",
            backgroundColor: "#F5F6F7",
            cursor: "not-allowed",
            pointerEvents: "none"
        },
        passwordOk: {
            border: "2px solid #01AA59",
        },
        eyePassword: {
            position: "absolute",
            right: "16px",
            top: "16px",
            cursor: "pointer",
        }
    })
)
